/* @flow */
/*
 *  Copyright 2018 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

/**
 * @class
 */

import Dialog from '@react/react-spectrum/Dialog';
import * as React from 'react';
import Button from '@react/react-spectrum/Button';
import './InformationDialog.scss';

type Props = {
	dialogConfig: Object
};


class InformationDialog extends React.Component<Props> {
	escapeHandler: Function;

	constructor(props: Object) {
		super(props);
		this.escapeHandler = this.checkCloseDialog.bind(this);
	}

	checkCloseDialog(e: Object) {
		const informationDialog = document.querySelector('.informationDialog');
		if (informationDialog) {
			e.stopPropagation();
		}
	}

	componentWillUnmount() {
		if (document.body) {
			document.body.removeEventListener('keydown', this.escapeHandler);
		}
	}

	componentDidMount() {
		if (document.body) {
			document.body.addEventListener('keydown', this.escapeHandler);
		}
	}


	render() {
		return <Dialog id='informationDialog' title={this.props.dialogConfig.title} className='informationDialog'>
			<div className='informationDialogContent'>
				<div>{this.props.dialogConfig.desc}</div>
				<div className='btn'>
					<Button key={`${this.props.dialogConfig.OK.value.toLowerCase()}_enterpriseUser`}
						onClick={() => {
							this.props.dialogConfig.OK.onClick();
						}} label={this.props.dialogConfig.OK.value} variant='cta'/>
				</div>
			</div>
		</Dialog>;
	}
}

export default InformationDialog;
